import { render, staticRenderFns } from "./IssueListFooter.vue?vue&type=template&id=f792bab2"
import script from "./IssueListFooter.vue?vue&type=script&lang=js"
export * from "./IssueListFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports